/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LaboratoryDTO,
    LaboratoryDTOFromJSON,
    LaboratoryDTOFromJSONTyped,
    LaboratoryDTOToJSON,
} from './LaboratoryDTO';

/**
 * 
 * @export
 * @interface LaboratoryDTOPagedResponse
 */
export interface LaboratoryDTOPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof LaboratoryDTOPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof LaboratoryDTOPagedResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof LaboratoryDTOPagedResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<LaboratoryDTO>}
     * @memberof LaboratoryDTOPagedResponse
     */
    data?: Array<LaboratoryDTO> | null;
}

export function LaboratoryDTOPagedResponseFromJSON(json: any): LaboratoryDTOPagedResponse {
    return LaboratoryDTOPagedResponseFromJSONTyped(json, false);
}

export function LaboratoryDTOPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaboratoryDTOPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(LaboratoryDTOFromJSON)),
    };
}

export function LaboratoryDTOPagedResponseToJSON(value?: LaboratoryDTOPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'totalCount': value.totalCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(LaboratoryDTOToJSON)),
    };
}

